import { PxdAgGridColumnTypes, PxdAgGridDefaultColumnDef, PxdAgGridExcelStyles, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions, PXDDefaultExcelExportParams } from '@app/shared/aggrid/pxd-ag-grid-options';

export const drillGroupMappingGridOptions: PxdAgGridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  rowSelection: { mode: 'multiRow', headerCheckbox: true, selectAll: 'all' },
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  excelStyles: PxdAgGridExcelStyles,
  defaultExcelExportParams: PXDDefaultExcelExportParams,
  columnDefs: [
    { field: 'ActualDrillGroupReference', headerName: 'Drill Group ID', width: 150 },
    { field: 'Description', type: ['textColumn'], width: 1000 },
    { field: 'SSNs', headerName: 'SSNs', type: ['textColumn'], width: 500 }
  ]
};